import React from "react";
import { XAxis, YAxis } from "../hooks/useBarChartFormState";
import { Input, Select, TextArea } from "@aidkitorg/component-library";
import { useLocalizedStrings } from "../../../Localization";
import { useFieldOptions } from "../../hooks/useFieldOptions";

export type BarChartFormFieldsProps = {
  title: string,
  setTitle: (val: string) => void,

  description: string,
  setDescription: (val: string) => void,

  xAxis: XAxis,
  setXAxis: (val: XAxis) => void,

  yAxis: YAxis,
  setYAxis: (val: YAxis) => void,
}

export const BarChartFormFields: React.FC<BarChartFormFieldsProps> = ({
  title, setTitle,
  description, setDescription,
  xAxis, setXAxis,
  yAxis, setYAxis,
}) => {
  const L = useLocalizedStrings()
  const { fieldOptions, getSelectedFieldOption } = useFieldOptions()

  return <>
    <Input 
      required
      label={L.admin_panel.dashboards.chart_title}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
    />
    
    <Input
      required
      label={L.admin_panel.dashboards.y_axis_title}
      placeholder={L.admin_panel.dashboards.y_axis_title_placeholder}
      value={yAxis.title}
      onChange={(e) => setYAxis({...yAxis, title: e.target.value})}
    />
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">
        {L.admin_panel.dashboards.y_axis_values}
      </label>
      <div className="text-sm text-gray-600 bg-gray-50 p-3 rounded-md border">
        📊 <strong>{L.admin_panel.dashboards.applicant_count}</strong> - {L.admin_panel.dashboards.applicant_count_bar_chart_desc}
      </div>
    </div>

    <Input 
      required
      placeholder={L.admin_panel.dashboards.x_axis_title_placeholder}
      label={L.admin_panel.dashboards.x_axis_title}
      value={xAxis.title}
      onChange={(e) => setXAxis({...xAxis, title: e.target.value})}
    />
    <Select
      required
      portal
      hideLabel
      virtualized
      options={[
        ...fieldOptions.filter(option => option.value !== xAxis.secondaryField)
      ]}      
      label={L.admin_panel.dashboards.group_by}
      description={L.admin_panel.dashboards.group_by_description}
      labelLocation="above"
      value={getSelectedFieldOption(xAxis.primaryField)}
      onChange={(value) => {
        if (value) setXAxis({...xAxis, primaryField: value.value})
      }}
      placeholder={L.admin_panel.dashboards.x_axis_placeholder}
      searchable
    />
    <Select
      portal
      virtualized
      showDescription
      options={[
        ...fieldOptions.filter(option => option.value !== xAxis.primaryField)
      ]}
      label={L.admin_panel.dashboards.group_by}
      description={L.admin_panel.dashboards.group_by_secondary_desc}
      labelLocation="above"
      value={getSelectedFieldOption(xAxis.secondaryField || "")}
      onChange={(value) => {
        setXAxis({...xAxis, secondaryField: value?.value || ''})
      }}
      placeholder={L.admin_panel.dashboards.x_axis_placeholder}
      searchable
    />

    <TextArea
      label={L.admin_panel.dashboards.description}
      showLabel
      value={description}
      onChange={(e) => setDescription(e.target.value)}
    />
  </>
}